import gsap from 'gsap';

export default class {

	constructor() {
		// on document load
		document.addEventListener('DOMContentLoaded', () => {
			setTimeout(() => {
				document.querySelectorAll('.BlockHomeAnimation').forEach((el) => {
					this.init(el);
				});
			}, 300);
		});

	}

    init(el) {
		const mainBackground = el.querySelector('.BlockHomeAnimation__background');
		const endBackground = el.querySelector('.BlockHomeAnimation__mainBackground');
		const content = el.querySelector('.BlockHomeAnimation__contentInner');
		const title = el.querySelector('.BlockHomeAnimation__title');
		const logo = el.querySelector('.BlockHomeAnimation__logo');
		const overlay = el.querySelector('.BlockHomeAnimation__overlay');

	  	gsap.to(logo, {
			opacity: 1,
			duration: 0.5,
		})
		gsap.to(logo, {
			scale: 12,
			duration: 2,
			delay: 1,
			bottom: '-2%',
			opacity: 0,
		})
		gsap.to(title, {
			y: '-' + (title.offsetHeight + 30) + 'px',
			duration: 3,
			delay: 2.5,
			ease: 'elastic.out(1.1,0.5)',
		})
		gsap.to(overlay, {
			opacity: 1,
			duration: 1,
			delay: 3,
		})
		gsap.to(mainBackground, {
			opacity: 0.8,
			duration: 1,
			delay: 4,
		})
		gsap.to(title, {
			y: 0,
			duration: 2,
			delay: 5,
		})
		gsap.to(content, {
			y: 0,
			duration: 3.5,
			delay: 5,
			ease: 'elastic.out(1,0.8)',
		})
		gsap.to(endBackground, {
			opacity: 1,
			duration: 1.5,
			delay: 5,
		})
    }

	ini2() {
		const horizontalSections = gsap.utils.toArray('.BlockTimeline')

		horizontalSections.forEach(function (sec, i) {


			var getToValue = () => -(thisAnimWrap.scrollWidth - window.innerWidth);

			if (window.innerWidth >= 768) {
				gsap.fromTo(thisAnimWrap, {
					x: () => 0
				}, {
					x: () => getToValue(),
					ease: "none",
					scrollTrigger: {
						trigger: sec,
						start: "top top",
						end: () => "+=" + (thisAnimWrap.scrollWidth - window.innerWidth),
						pin: thisPinWrap,
						invalidateOnRefresh: true,
						// anticipatePin: 1,
						scrub: true,
						// markers: true,
						onUpdate: self => {

							statusElement.querySelector('span').innerHTML = Math.round(self.progress * 100) + "%";
							// set the left position of the status element.
							gsap.set(statusElement, {
								left: () => {
									return (statusWrapperElement.getBoundingClientRect().width - statusElement.getBoundingClientRect().width) * self.progress + (16 * self.progress - 8);
								}
							});
						},
					}
				});
			} else {
				// on mobile we have plain stacked sections, status is based purely on scroll position of the wrapper element, but takes into account variable section heights
				window.addEventListener("scroll", () => {
					const wrapperPosition = sec.getBoundingClientRect().top + document.documentElement.scrollTop;
					const wrapperHeight = sec.getBoundingClientRect().height;
					const scrollPosition = document.documentElement.scrollTop;
					const scrollPositionInWrapper = scrollPosition - wrapperPosition;
					const lastSectionPosition = sections[sections.length - 1].getBoundingClientRect().top + document.documentElement.scrollTop;
					const lastSectionHeight = sections[sections.length - 1].getBoundingClientRect().height;
					const progress = scrollPositionInWrapper / (wrapperHeight - lastSectionHeight);
					const progressInPercent = Math.round(progress * 100);
					// statusElement.querySelector('span').innerHTML = progressInPercent + "%";
					let left = (statusWrapperElement.getBoundingClientRect().width - statusElement.getBoundingClientRect().width) * progress + (16 * progress - 8);
					if (left < -8) {
						left = -8;
					}
					if (left > statusWrapperElement.getBoundingClientRect().width - statusElement.getBoundingClientRect().width + 8) {
						left = statusWrapperElement.getBoundingClientRect().width - statusElement.getBoundingClientRect().width + 8;
					}
					gsap.set(statusElement, {
						left: () => {
							return left;
						}
					});
					navWrapperOverflow.scrollLeft = (progress - 0.2) * navWrapperOverflow.scrollWidth;

				});
			}

			// on progress element click, scroll to that section
			progressElements.forEach((el, i) => {
				el.addEventListener("click", (event) => {

					if (window.innerWidth >= 768) {
						event.preventDefault();
						const pin = sec.querySelector('.pin-spacer');
						const pinPosition = sec.getBoundingClientRect().top + document.documentElement.scrollTop;;
						if (pin) {

							window.scrollTo({
								top: pinPosition + (window.innerWidth) * i,
								behavior: "smooth"
							});
						}
					} else {
					}
				});
			});

		});
	}

}
